import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  useContext,
} from "react";

import PublishIcon from '@mui/icons-material/Publish';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { SimpleDialog, Button } from "simple-ui-components";

import { post } from "../../server-requests/serverRequests";
import { AuthContext } from "../authContextProvider";
import { getCroppedImg } from "../shared/cropImageScript";
import { getTranslation } from "../languageProvider";
import { Log } from "../shared/utility";

export const UploadLogo = React.memo(({ Success }) => {
  const { Dialog, DialogBody, DialogFooter } = SimpleDialog;

  const inputElement = useRef(null);

  const { snackbarHandler } = useContext(AuthContext);

  const [open, setOpen] = useState(false);

  const [src, setSrc] = useState(null);
  const [crop, setCrop] = useState({
    unit: "%",
    width: 80,
    aspect: 4 / 1,
  });
  const [currentImage, setCurrentImage] = useState(null);
  // const [croppedImgURl, setCroppedImgURl] = useState(null);
  const [finalFile, setFinalFile] = useState(null);

  const [sendData, setSendData] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);

    // clear old uploaded file from file input
    inputElement.current.value = null;
  }, []);

  const handleImageLoaded = (image) => setCurrentImage(image);

  const onSelectFile = (e) => {
    setCrop({ unit: "%", width: 80, aspect: 4 / 1 });
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setSrc(reader.result);
        setOpen(true);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onCropComplete = (crop) => {
    setCrop(crop);
    generateCroppedImage(crop);
  };

  const generateCroppedImage = useCallback(
    async (crop, isSave) => {
      if (currentImage && crop.width && crop.height) {
        // can get final file and cropped image URL {url, file}
        const { file } = await getCroppedImg(
          currentImage,
          crop,
          "newImage.jpeg"
        );
        setFinalFile(file);
        setSendData(isSave);
      }
    },
    [currentImage]
  );

  const handleOnCropChange = (crop) => setCrop(crop);

  const updateImagesClickHandler = useCallback(() => {
    generateCroppedImage(crop, true);
    handleClose();
  }, [crop, generateCroppedImage, handleClose]);

  useEffect(() => {
    let isMounted = true;
    if (sendData && finalFile) {
      let toSend = new FormData();
      toSend.append("image", finalFile);
      post("companies/logo", toSend)
        .then(() => {
          if (isMounted) {
            setSendData(false);
            setFinalFile(null);
            Success();
          }
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
          Log("Error: post-routes/points/images:" + status);
        });
    }
    return () => (isMounted = false);
  }, [sendData, finalFile, Success, snackbarHandler]);

  return (
    <>
      <Button
        clicked={() => {
          inputElement.current.click();
        }}
        className="btn-secondary"
      >
        <PublishIcon /> {getTranslation("0147")}
        <input
          type="file"
          onChange={onSelectFile}
          style={{ display: "none" }}
          ref={inputElement}
        />
      </Button>
      {open && (
        <Dialog
          theme="default"
          size="sm"
          close={handleClose}
          open={open}
          title={getTranslation("0020")}
        >
          <DialogBody>
            <ReactCrop
              src={src}
              crop={crop}
              onImageLoaded={handleImageLoaded}
              onComplete={onCropComplete}
              onChange={handleOnCropChange}
            />
          </DialogBody>
          <DialogFooter multiple={true}>
            <Button
              theme="default"
              type="button"
              clicked={updateImagesClickHandler}
              icon={<SaveOutlinedIcon />}
              className="btn-primary"
              text={getTranslation("0024")}
            />
          </DialogFooter>
        </Dialog>
      )}
    </>
  );
});
